export default __webpack_public_path__ + "static/media/pie-chart_header.5d793130.svg";